import { FETCH_ALL_PROFORMA_INVOICES, DELETE_PROFORMA_INVOICE, CREATE_PROFORMA_INVOICE } from "../actions/types";
import _ from 'lodash';
const INITIAL_STATE = {data: {},paginate:{}}

export default (state=INITIAL_STATE, action) => {
    switch (action.type) {
        case FETCH_ALL_PROFORMA_INVOICES:
            const paginate = _.omit(action.payload, 'data');
            return {...state, data:_.mapKeys(action.payload.data, 'id'), paginate}
        case DELETE_PROFORMA_INVOICE:
            return {...state, data:_.omit(state.data, action.payload)};
        case CREATE_PROFORMA_INVOICE:
            return {...state, data:{ ...state.data, [action.payload.id]:action.payload }}
        default:
            return state;
    }
}